"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbButtonBar = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sbNonEditableControl = require("../sb-non-editable-control");

var _isTriggeredInside = require("../../skybase-core/utils/is-triggered-inside");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @namespace skybase-components.sb-button-bar
 *
 * @public
 *
 * @class
 * @classdesc
 * Wrapper for radio buttons, styled according to the GUI Guideline.
 */
var SbButtonBar = /*#__PURE__*/function (_Component) {
  _inherits(SbButtonBar, _Component);

  var _super = _createSuper(SbButtonBar);

  /**
   * @desc
   * Constructor for this class.
   *
   * @public
   * @method
   * @constructor
   *
   * @param {object}  props   - Properties passed from source element.
   */
  function SbButtonBar(props) {
    var _this;

    _classCallCheck(this, SbButtonBar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function () {
      var disabled = _this.props.disabled;

      if (disabled) {
        return;
      }

      _this.setIsFocused(true);
    });

    _this.state = {
      focused: false
    };
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * @desc
   * Triggers when our component was mounted. We'll bind our clickOutside handler.
   *
   * @private
   * @method
   */


  _createClass(SbButtonBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var editable = this.props.editable;

      if (editable === false) {
        return;
      }

      window.addEventListener('click', this.handleClickOutside);
    }
    /**
     * @desc
     * Triggers when our component was unmounted. We'll unbind our clickOutside handler.
     *
     * @private
     * @method
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var editable = this.props.editable;

      if (editable === false) {
        return;
      }

      window.removeEventListener('click', this.handleClickOutside);
    }
    /**
     * @desc
     * Returns calculated class names based on its conditions.
     *
     * @private
     * @function
     *
     * @param {object}    props   - Properties passed into this component.
     * @param {object}    state   - Current state.
     *
     * @returns {string}  *       - List of classes, joined with space.
     */

  }, {
    key: "getClassNames",
    value: function getClassNames(props, state) {
      return (0, _classnames.default)('sb-button-bar', props.className, {
        focused: state.focused,
        disabled: props.disabled
      });
    }
    /**
     * @desc
     * Sets focused state for this component.
     *
     * @private
     * @method
     *
     * @param {boolean} bool  - TRUE if is focused, FALSE if not.
     */

  }, {
    key: "setIsFocused",
    value: function setIsFocused(bool) {
      this.setState({
        focused: bool
      });
    }
    /**
     * @desc
     * Handler for clickOutside event. It handles all click events in current window
     * and decides if target element belongs to our component or not).
     *
     * @private
     * @method
     *
     * @param {object} event   - Event triggered.
     */

  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      // if this event was triggered inside of our component, ignore it
      if ((0, _isTriggeredInside.isTriggeredInside)(this.node, event)) {
        return;
      }

      this.handleOnBlur();
    }
    /**
     * @desc
     * Fires when user has clicked outside our component.
     *
     * @private
     * @method
     */

  }, {
    key: "handleOnBlur",
    value: function handleOnBlur() {
      var focused = this.state.focused;

      if (focused) {
        this.setIsFocused(false);
      }
    }
    /**
     * @desc
     * Fires when user has clicked inside our component.
     *
     * @private
     * @method
     */

  }, {
    key: "render",

    /**
     * @desc
     * Main render routine.
     *
     * @public
     * @function
     *
     * @returns {React.Component} *   - Rendered react component.
     */
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          editable = _this$props.editable,
          className = _this$props.className,
          id = _this$props.id,
          children = _this$props.children,
          disabled = _this$props.disabled,
          style = _this$props.style,
          rest = _objectWithoutProperties(_this$props, ["editable", "className", "id", "children", "disabled", "style"]);

      var classNames = this.getClassNames(this.props, this.state);
      /**
       * If editable=false was set, render just selected button.
       */

      if (editable === false) {
        var childrenAsArray = _react.default.Children.toArray(children);

        var selectedButton = childrenAsArray.find(function (child) {
          return child.props.checked === true;
        });

        if (selectedButton) {
          return /*#__PURE__*/_react.default.createElement(_sbNonEditableControl.SbNonEditableControl, {
            value: selectedButton.props.children,
            id: id,
            className: className
          });
        }

        return /*#__PURE__*/_react.default.createElement(_sbNonEditableControl.SbNonEditableControl, {
          value: "",
          id: id,
          className: className
        });
      } // inject 'disabled' prop to ensure proper behaviour


      var childrenWithProps = _react.default.Children.toArray(children).filter(function (child) {
        return !!child;
      }) // remove nullish children
      .map(function (child) {
        var _child$props, _child$props2;

        return _react.default.cloneElement(child, {
          disabled: disabled,
          className: (0, _classnames.default)(child === null || child === void 0 ? void 0 : (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.className, 'sb-btn', {
            primary: child === null || child === void 0 ? void 0 : (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.checked
          }),
          role: 'radio'
        });
      });

      return /*#__PURE__*/_react.default.createElement("div", _extends({}, rest, {
        ref: function ref(node) {
          _this2.node = node;
        },
        onClick: this.handleOnClick,
        className: classNames,
        id: id,
        style: style,
        role: "radiogroup",
        tabIndex: disabled ? -1 : 0
      }), childrenWithProps);
    }
  }]);

  return SbButtonBar;
}(_react.Component);

exports.SbButtonBar = SbButtonBar;
SbButtonBar.propTypes = {
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  editable: _propTypes.default.bool,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  style: _propTypes.default.object // eslint-disable-line

};
SbButtonBar.defaultProps = {
  className: null,
  id: null,
  disabled: false,
  editable: true,
  style: null
};
//# sourceMappingURL=sb-button-bar.js.map